/* COLORS */

export const colorWhite = '#fff';
export const colorBlack = '#111';

export const colorBlueDark = '#1a3a56';
export const colorBlue = '#306ea4';
export const colorBlueLight = '#70a0c9';
export const colorBlueVeryLight = '#eef7ff';
export const colorGrey = '#616161';
export const colorGreyLight = '#dbdbdb';
export const colorRed = '#d73f3b';
export const colorYellowLight = 'hsl(47.7, 100%, 85.7%)';
export const colorYellow = 'hsl(47.7, 70%, 60.7%)';
export const colorYellowDark = 'hsl(47.7, 70%, 22.2%)';

export const colorText = colorGrey;

/* SIZE */

export const appHeaderHeight = '6rem';
export const compactAppHeaderHeight = '2.3rem';
export const breadcrumbsHeight = '2.5rem';

/* STYLE */

export const border = `1px solid ${colorGreyLight}`;
export const borderBold = `1px solid ${colorGrey}`;
